import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";


const ProtectedRoutes = ({roles}) => {
    const { isAuthenticated, user } = useSelector(state => state.auth)
    console.log('isAuthenticad:', isAuthenticated);
    console.log('user:', user);
    
    
    if(!isAuthenticated) {
        return <Navigate to="/login" />
    }     

    if (roles && !roles.some(role => user.type.includes(role))) {
         Swal.fire("Usuarios sin permisos")
         return <Navigate to="/login" />
    }

    return <Outlet />
}

export default ProtectedRoutes;